import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { ListingStage } from 'models/Listing';
import { checkIsEnded, checkIsPaused } from 'utils';
import { DEAL_STAGE, DealStage } from 'models/DealRoom';
import { DEAL_STATUS_LABEL } from 'data/dealStatus';

import './BusinessDetailsBadge.styles.scss';

type BusinessDetailsBadgeProps = {
  className?: string;
  stage: ListingStage;
  dealStage: DealStage;
};

const PRIVILEGED_STATUSES: DealStage[] = [
  DEAL_STAGE.UNDER_CONTRACT,
  DEAL_STAGE.UNDER_OFFER,
];

const BusinessDetailsBadge: React.FC<BusinessDetailsBadgeProps> = (props) => {
  const { className, stage, dealStage } = props;

  const { t } = useTranslation();

  const isEnded = useMemo(() => checkIsEnded(stage), [stage]);
  const isPaused = useMemo(() => checkIsPaused(stage), [stage]);
  const isPrivileged = useMemo(
    () => PRIVILEGED_STATUSES.includes(dealStage),
    [dealStage],
  );

  const classes = classNames(
    'business-details-badge',
    { orange: !isEnded, red: isEnded },
    className,
  );

  const copy = useMemo(() => {
    if (isEnded) return t('campaignExpired');

    if (isPrivileged && isPaused) return t(DEAL_STATUS_LABEL[dealStage]);

    if (isPaused) return t('paused');

    return '';
  }, [dealStage, isEnded, isPaused, isPrivileged, t]);

  if (!copy) return null;

  return (
    <div className={classes}>
      <div>{copy}</div>
    </div>
  );
};

export default BusinessDetailsBadge;
